/**
 * PlaceExpander - Editable Place field with Location in expandable subsection
 * Uses ExpandableEditableItem for clean implementation
 */

import React from 'react';
import { ExpandableEditableItem } from './ExpandableEditableItem';
import { MaskedLocation } from './MaskedLocation';

export interface PlaceExpanderProps {
    chartId: string;
    placeName: string;
    location?: string;
    disabled?: boolean;
}

export const PlaceExpander: React.FC<PlaceExpanderProps> = ({
    chartId,
    placeName,
    location,
    disabled = false
}) => {
    // Location content for expanded section
    const locationContent = location ? (
        <div className="planet-detail-row">
            <span className="planet-detail-label" style={{ fontSize: '0.85em', color: 'var(--chakra-colors-gray-500)' }}>
                Location:
            </span>
            <MaskedLocation location={location} />
        </div>
    ) : undefined;

    return (
        <ExpandableEditableItem
            chartId={chartId}
            label="Place"
            fieldKey="place_name"
            initialValue={placeName}
            disabled={disabled}
            getValuePath={(resp) => resp.basic_info?.place_name || ''}
            setValueInResponse={(resp, value) => ({
                ...resp,
                basic_info: { ...resp.basic_info, place_name: value }
            })}
            expandedContent={locationContent}
            ariaControlsId={`place-location-${chartId}`}
        />
    );
};
